import { createContext, useCallback, useReducer } from "react";
import ComplaintReducer from "./ComplaintReducer";
import { getComplaints } from "./apiCalls"; // change to your actual path

const INITIAL_STATE = {
    complaints: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const ComplaintContext = createContext(INITIAL_STATE);

export const ComplaintContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        ComplaintReducer,
        INITIAL_STATE
    );

    const fetchComplaints = useCallback(
        async (toast, forceRefresh = false) => {
            // Already fetched → don't make another API request
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getComplaints(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <ComplaintContext.Provider
            value={{
                complaints: state.complaints,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchComplaints,
            }}
        >
            {children}
        </ComplaintContext.Provider>
    );
};